export default __webpack_public_path__ + "static/media/MapEditor.6f401478.mp4";